import React, { useEffect, useState } from "react";
import SellNew from "./sellNonMotor/SellNew";
import { Tabs, Empty } from "antd";
import MenuBar from "../menu/MenuBar";
import SellOld from "./sellNonMotor/SellOld";
import { useSelector, useDispatch } from "react-redux";
function SellNonMotor() {
  const onChange = (key) => {
    console.log(key);
  };
  const items = [
    {
      key: "1",
      label: "ສຳຫຼັບລູກຄ້າທີ່ຍັງບໍ່ເຄີຍຊື້ປະກັນໄພນຳບໍລິສັດມາກ່ອນ",
      children: <SellNew />,
    },
    {
      key: "2",
      label: "ສຳຫຼັບລູກຄ້າທີ່ເຄີຍຊື້ປະກັນໄພນຳບໍລິສັດແລ້ວ",
      children: <SellOld />,
    },
  ];
  const userData = useSelector((state) => state.user);
  const [show, set_show] = useState(false);
  useEffect(() => {
    try {
      let d = userData?.agent_conf;
      let obj = JSON.parse(d);
      set_show(obj?.non_motor);
    } catch (error) {
      set_show(false);
      console.log("Parsing error:", error);
    }
  }, [userData]);

  return (
    <div>
      {/* {userData} */}
      <MenuBar />

      {show ? (
        <Tabs centered defaultActiveKey="2" items={items} onChange={onChange} />
      ) : (
        <div className="mt-5">
          <Empty />
          <h2 className="text-center text-xl">
            ຍັງບໍ່ທັນໃດ້ລົງທະບຽນຂາຍປະກັນໄພ
          </h2>
        </div>
      )}
    </div>
  );
}

export default SellNonMotor;



